import React from 'react'

import PayMeYouLinkCard from './PayMeYouLinkCard'
import ConsentListSectionHeader from './ConsentListSectionHeader'

import style from './LinkGroup.module.css'

export default function LinkGroup({
  groupedLinkData,
  considerPointedBorder,
  description,
}) {
  return groupedLinkData.keySeq().map((key, index) => {
    return (
      <div className={style.group} key={key}>
        <ConsentListSectionHeader
          count={groupedLinkData.get(key).size}
          label={key}
          description={description}
          consentType="payMeYou"
          indented
          pointedBorder={considerPointedBorder && index === 0}
        />
        <div>
          {groupedLinkData.get(key).map(item => {
            return (
              <PayMeYouLinkCard
                key={item.get('id')}
                link={item}
                index={item.get('id')}
              />
            )
          })}
        </div>
      </div>
    )
  })
}
